import React from 'react';
import usePositionsSettingsFilterOptions from '../../../hooks/usePositionsSettingsFilterOptions';

const PositionsSettingsChip = ({ slug, value }) => {
  const options = usePositionsSettingsFilterOptions();

  return (
    <>
      {value
        .map((item) => (options[slug] || []).find((option) => option.value === item)?.label)
        .filter(Boolean)
        .join(', ')}
    </>
  );
};

export default PositionsSettingsChip;
